import {getCountFromServer, query, where} from 'firebase/firestore';
import getQuestionCollectionRef from './getQuestionCollectionRef';

export default async function countQuestionsBySeedQuestionDoc(
  moduleId: string,
  seedQuestionId: string,
): Promise<number> {
  const col = getQuestionCollectionRef(moduleId);
  const q = query(col, where('seedQuestionId', '==', seedQuestionId));
  const agg = await getCountFromServer(q);
  return agg.data().count;
}
